// import { getUserProfile } from "../../../features/authentication/services/getUserProfile";
// import {
//   changePassword,
//   loginSendMobile,
//   loginWithPassword,
// } from "../../../features/authentication/services/login";

import { loginWithPassword } from "../../../features/authentication/services/login";
import { getUsers } from "../../../features/users/services/get-users";

export const userExtraReducers = {
  //   [loginSendMobile.fulfilled]: (state) => {
  //     state.pending = false;
  //   },
  //   [loginSendMobile.pending]: (state) => {
  //     state.pending = true;
  //   },
  [loginWithPassword.fulfilled]: (state, { payload }) => {
    state.pending = false;
    state.userAuthToken = payload?.data?.token;
    state.loginUserProfile = payload?.data?.user;
  },

  [getUsers.fulfilled]: (state, { payload }) => {
    state.pending = false;
    state.allUsers = payload?.data;
  },
  //   [loginWithPassword.pending]: (state) => {
  //     state.pending = true;
  //   },
  //   [getUserProfile.fulfilled]: (state, { payload }) => {
  //     state.pending = false;
  //     state.userProfile = payload.data;
  //   },
  //   [getUserProfile.pending]: (state) => {
  //     state.pending = true;
  //   },
  //   [changePassword.fulfilled]: (state) => {
  //     state.pending = false;
  //   },
  //   [changePassword.pending]: (state) => {
  //     state.pending = true;
  //   },
};
